import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { translate, userLogout } from 'admin-on-rest';
import { Link } from 'react-router-dom';

import DashboardIcon from 'material-ui/svg-icons/action/dashboard';
import ExitIcon from 'material-ui/svg-icons/action/power-settings-new';
import CustomerIcon from 'material-ui/svg-icons/social/person';
import MoneyIcon from 'material-ui/svg-icons/editor/attach-money';
import CogIcon from 'material-ui/svg-icons/action/settings';
import ListIcon from 'material-ui/svg-icons/action/list';
import WarnIcon from 'material-ui/svg-icons/alert/error-outline';
import MouseIcon from 'material-ui/svg-icons/hardware/mouse';
import ArrowRight from 'material-ui/svg-icons/navigation/arrow-forward';
import StarIcon from 'material-ui/svg-icons/toggle/star';
import BarChart from 'material-ui/svg-icons/editor/insert-chart';
import ReceiptIcon from 'material-ui/svg-icons/action/receipt';
import LinkIcon from 'material-ui/svg-icons/content/link';
import WebIcon from 'material-ui/svg-icons/av/web';
import GavelIcon from 'material-ui/svg-icons/action/gavel';
import HistoryIcon from 'material-ui/svg-icons/action/history';
import BlockIcon from 'material-ui/svg-icons/content/block';
import ChartBubbleIcon from 'material-ui/svg-icons/editor/bubble-chart';
import PieChartIcon from 'material-ui/svg-icons/editor/pie-chart';
import CalendarIcon from 'material-ui/svg-icons/action/event';
import SendIcon from 'material-ui/svg-icons/content/send';
import LinkSettingsIcon from 'material-ui/svg-icons/action/build';
import InfoIcon from 'material-ui/svg-icons/action/info-outline';

const STORAGE_KEY = 'cloudhints_menu_groups';

const groups = [
    {
        key: 'sites',
        label: 'Sites & advertenties',
        icon: <WebIcon />,
        items: [
            { name: 'admin/cloudhintsdomains',     label: 'Cloudhints sites',           icon: <WebIcon /> },
            { name: 'admin/ad',                    label: 'Alle advertenties',          icon: <MoneyIcon /> },
            { name: 'admin/bidhistory',            label: 'Biedingen geschiedenis',     icon: <HistoryIcon /> },
            { name: 'admin/outgoinglink',          label: 'Uitgaande links (actief)',   icon: <ArrowRight /> },
            { name: 'admin/outgoinglinkdeleted',   label: 'Uitgaande links (inactief)', icon: <ArrowRight /> },
        ],
    },
    {
        key: 'stats',
        label: 'Stats',
        icon: <BarChart />,
        items: [
            { name: 'admin/clicks_report_sitegrouped',     label: 'Per site',           icon: <BarChart /> },
            { name: 'admin/clicks_report_customergrouped', label: 'Per klant',          icon: <ChartBubbleIcon /> },
            { name: 'admin/clicks_report_gcrgrouped',      label: 'Per GCR (Adwords)',  icon: <PieChartIcon /> },
            { name: 'admin/clicks_report_monthgrouped',    label: 'Totalen per maand',  icon: <CalendarIcon /> },
        ],
    },
    {
        key: 'clicks',
        label: 'Kliks',
        icon: <MouseIcon />,
        items: [
            { name: 'admin/siteclick',                          label: 'Alle',                  icon: <MouseIcon /> },
            { name: 'admin/siteclick_blacklisted',              label: 'Bots op IP of UA',      icon: <BlockIcon /> },
            { name: 'admin/siteclick_blacklisted_startswith',   label: 'Bots op IP-startswith', icon: <BlockIcon /> },
            { name: 'admin/siteclick_blacklisted_ai',           label: 'Bots op gedrag',        icon: <BlockIcon /> },
            { name: 'admin/siteclick_filtered_doubles',         label: 'Uitgefilterde dubbele', icon: <BlockIcon /> },
            { name: 'admin/ipblacklist',                        label: 'IP Blacklist',          icon: <GavelIcon /> },
            { name: 'admin/useragent_blacklist',                label: 'User-agent blacklist',  icon: <GavelIcon /> },
            { path: '/klik-fraude-uitleg',                      label: 'Uitleg voor klanten',   icon: <InfoIcon /> },
        ],
    },
    {
        key: 'invoicing',
        label: 'Facturatie',
        icon: <ReceiptIcon />,
        custom: [
            { path: '/facturatie', label: 'Verstuur facturen',     icon: <SendIcon /> },
            { path: '/silvasoft',  label: 'Silvasoft koppeling',   icon: <LinkSettingsIcon /> },
        ],
    },
    {
        key: 'misc',
        label: 'Overig',
        icon: <ListIcon />,
        items: [
            { name: 'public/lasthundred', label: 'Reviews (laatste 100)', icon: <StarIcon /> },
            { name: 'admin/adminlog',     label: 'Log',                   icon: <WarnIcon /> },
        ],
    },
];

const ROW_HEIGHT     = 38;
const ROW_PAD_LEFT   = 18;
const NESTED_PAD     = 30;
const ICON_SIZE      = 18;
const FONT_SIZE      = 13;
const FONT_SIZE_NEST = 12;
const COLOR_TEXT     = '#37474f';
const COLOR_HOVER_BG = '#f0f4f8';
const COLOR_ACTIVE   = '#284263';

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: '100%',
        paddingTop: 16,
        paddingBottom: 4,
    },
    row: (indent, fontSize, fontWeight) => ({
        display: 'flex',
        alignItems: 'center',
        height: ROW_HEIGHT,
        paddingLeft: ROW_PAD_LEFT + indent,
        paddingRight: 14,
        fontSize,
        fontWeight,
        color: COLOR_TEXT,
        cursor: 'pointer',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        userSelect: 'none',
        transition: 'background 0.12s',
    }),
    iconWrap: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: ICON_SIZE + 6,
        marginRight: 8,
        flexShrink: 0,
    },
    label: {
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    chevron: {
        fontSize: 10,
        color: '#90a4ae',
        marginLeft: 4,
        transition: 'transform 0.15s',
    },
    sectionDivider: {
        height: 1,
        background: '#eceff1',
        margin: '4px 12px',
    },
};

const renderIcon = (icon, color) => {
    if (!icon) return <span />;
    return React.cloneElement(icon, {
        color: color || '#607d8b',
        style: { width: ICON_SIZE, height: ICON_SIZE, ...(icon.props.style || {}) },
    });
};

class Row extends Component {
    state = { hover: false };
    onEnter = () => this.setState({ hover: true });
    onLeave = () => this.setState({ hover: false });
    render() {
        const { icon, label, fontSize, fontWeight, indent, onClick, asLink, to } = this.props;
        const { hover } = this.state;
        const style = {
            ...styles.row(indent || 0, fontSize, fontWeight),
            background: hover ? COLOR_HOVER_BG : 'transparent',
        };
        const inner = [
            <span key="i" style={styles.iconWrap}>{renderIcon(icon, hover ? COLOR_ACTIVE : '#607d8b')}</span>,
            <span key="l" style={styles.label}>{label}</span>,
        ];
        if (asLink) {
            return (
                <Link to={to} onClick={onClick} style={style} onMouseEnter={this.onEnter} onMouseLeave={this.onLeave}>
                    {inner}
                </Link>
            );
        }
        return (
            <div style={style} onClick={onClick} onMouseEnter={this.onEnter} onMouseLeave={this.onLeave}>
                {inner}
            </div>
        );
    }
}

class GroupHeader extends Component {
    state = { hover: false };
    onEnter = () => this.setState({ hover: true });
    onLeave = () => this.setState({ hover: false });
    render() {
        const { icon, label, open, onToggle } = this.props;
        const { hover } = this.state;
        return (
            <div
                style={{ ...styles.row(0, FONT_SIZE, 500), background: hover ? COLOR_HOVER_BG : 'transparent' }}
                onClick={onToggle}
                onMouseEnter={this.onEnter}
                onMouseLeave={this.onLeave}
            >
                <span style={styles.iconWrap}>{renderIcon(icon, hover ? COLOR_ACTIVE : '#607d8b')}</span>
                <span style={styles.label}>{label}</span>
                <span style={{ ...styles.chevron, transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}>▶</span>
            </div>
        );
    }
}

const loadOpen = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return { sites: true, stats: true, invoicing: true };
        return JSON.parse(raw);
    } catch (e) {
        return {};
    }
};

class CloudhintsMenu extends Component {
    state = { open: loadOpen() };

    toggle = (key) => () => {
        const next = { ...this.state.open, [key]: !this.state.open[key] };
        this.setState({ open: next });
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch (e) {}
    };

    handleLogout = () => {
        this.props.userLogout();
    };

    renderItem = (item) => {
        if (item.path) {
            return (
                <Row
                    key={item.path}
                    asLink
                    to={item.path}
                    icon={item.icon}
                    label={item.label}
                    fontSize={FONT_SIZE_NEST}
                    fontWeight={400}
                    indent={NESTED_PAD}
                    onClick={this.props.onMenuTap}
                />
            );
        }
        return (
            <Row
                key={item.name}
                asLink
                to={`/${item.name}`}
                icon={item.icon}
                label={item.label}
                fontSize={FONT_SIZE_NEST}
                fontWeight={400}
                indent={NESTED_PAD}
                onClick={this.props.onMenuTap}
            />
        );
    };

    render() {
        return (
            <div style={styles.main}>
                <Row
                    asLink
                    to="/"
                    icon={<DashboardIcon />}
                    label="Dashboard"
                    fontSize={FONT_SIZE}
                    fontWeight={500}
                    indent={0}
                    onClick={this.props.onMenuTap}
                />

                <Row
                    asLink
                    to="/admin/customers"
                    icon={<CustomerIcon />}
                    label="Portal gebruikers"
                    fontSize={FONT_SIZE}
                    fontWeight={500}
                    indent={0}
                    onClick={this.props.onMenuTap}
                />

                {groups.map((g) => (
                    <div key={g.key}>
                        <GroupHeader
                            icon={g.icon}
                            label={g.label}
                            open={!!this.state.open[g.key]}
                            onToggle={this.toggle(g.key)}
                        />
                        {!!this.state.open[g.key] && (g.items || g.custom).map(this.renderItem)}
                    </div>
                ))}

                <Row
                    icon={<ExitIcon />}
                    label="Uitloggen"
                    fontSize={FONT_SIZE}
                    fontWeight={500}
                    indent={0}
                    onClick={this.handleLogout}
                />
            </div>
        );
    }
}

const enhance = compose(
    connect(
        (state) => ({
            theme: state.theme,
            locale: state.locale,
        }),
        { userLogout }
    ),
    translate,
);

export default enhance(CloudhintsMenu);



// WEBPACK FOOTER //
// ./src/Menu.js